import React from "react";
import { ActionIcon } from "@mantine/core";
import { IconArrowsSort, IconCheck, IconRefresh } from "@tabler/icons-react";
import MaterialThreeDotMenu from "../../MaterialThreeDotMenu";

// Same height as Mantine's default (size="sm") TextInput, so this lines up
// exactly with the filter field it sits next to.
const CONTROL_HEIGHT = "var(--input-height-sm, 36px)";

// A sort control for Browse's mobile-style lists, built on the same
// three-dot menu the rest of the app uses (MaterialThreeDotMenu) — reused
// at both the Matters tier and the folder-contents tier with different
// `sortOptions`. The trigger shows the active option's label directly so
// the current sort is visible without opening the menu. An optional
// `onRefresh` renders a same-height refresh button right beside it.
const BrowseSortMenu = ({ sortOptions, activeSort, onChange, onRefresh }) => {
	const activeLabel = sortOptions.find((o) => o.key === activeSort)?.label;
	return (
		<div style={{ display: "flex", alignItems: "center", gap: 6 }}>
			{onRefresh ? (
				<ActionIcon
					variant="default"
					title="Refresh"
					onClick={onRefresh}
					style={{
						height: CONTROL_HEIGHT,
						width: CONTROL_HEIGHT,
						flexShrink: 0,
					}}
				>
					<IconRefresh size={16} />
				</ActionIcon>
			) : null}
			<MaterialThreeDotMenu
				position="relative"
				buttonContent={
					<SortTriggerButton>
						<IconArrowsSort size={16} style={{ flexShrink: 0 }} />
						{activeLabel}
					</SortTriggerButton>
				}
				menuItems={sortOptions.map(({ key, label }) => ({
					text: label,
					onSelect: () => onChange(key),
					iconComponent:
						key === activeSort ? (
							<IconCheck
								size={16}
								style={{ verticalAlign: "sub" }}
							/>
						) : (
							<span
								style={{ display: "inline-block", width: 16 }}
							/>
						),
				}))}
			/>
		</div>
	);
};

const SortTriggerButton = ({ children }) => (
	<span
		style={{
			display: "inline-flex",
			alignItems: "center",
			gap: 6,
			height: CONTROL_HEIGHT,
			boxSizing: "border-box",
			padding: "0 10px",
			borderRadius: 4,
			border: "1px solid var(--lw-medium-grey, #ccc)",
			background: "#fff",
			fontSize: 13,
			whiteSpace: "nowrap",
		}}
		title="Sort"
	>
		{children}
	</span>
);

export default BrowseSortMenu;
